import {
  SET_WIZARD_STEP, COMPLETE_WIZARD, RESET_ALL,
  ADD_INCOME, UPDATE_INCOME, REMOVE_INCOME,
  ADD_FIXED_EXPENSE, UPDATE_FIXED_EXPENSE, REMOVE_FIXED_EXPENSE,
  ADD_VARIABLE_EXPENSE, UPDATE_VARIABLE_EXPENSE, REMOVE_VARIABLE_EXPENSE,
  SET_GOALS,
  ADD_DEBT, UPDATE_DEBT, REMOVE_DEBT, SET_DEBT_STRATEGY,
  BATCH_SET_FIXED_EXPENSES, BATCH_SET_VARIABLE_EXPENSES,
  HYDRATE,
} from './budgetActions';

export const initialState = {
  wizardStep: 0,
  wizardCompleted: false,
  incomeSources: [],
  fixedExpenses: [],
  variableExpenses: [],
  goals: {
    savingsTargetPct: 20,
    emergencyFundMonths: 3,
    hasDebt: false,
    province: '',
  },
  debts: [],
  debtStrategy: 'avalanche',
  version: 2,
  lastSaved: null,
};

function updateItem(list, updated) {
  return list.map((item) => (item.id === updated.id ? { ...item, ...updated } : item));
}

export function budgetReducer(state, action) {
  switch (action.type) {
    case SET_WIZARD_STEP:
      return { ...state, wizardStep: action.payload };
    case COMPLETE_WIZARD:
      return { ...state, wizardCompleted: true, wizardStep: 4 };
    case RESET_ALL:
      return { ...initialState };

    // Income
    case ADD_INCOME:
      return { ...state, incomeSources: [...state.incomeSources, action.payload] };
    case UPDATE_INCOME:
      return { ...state, incomeSources: updateItem(state.incomeSources, action.payload) };
    case REMOVE_INCOME:
      return { ...state, incomeSources: state.incomeSources.filter((s) => s.id !== action.payload) };

    // Fixed expenses
    case ADD_FIXED_EXPENSE:
      return { ...state, fixedExpenses: [...state.fixedExpenses, action.payload] };
    case UPDATE_FIXED_EXPENSE:
      return { ...state, fixedExpenses: updateItem(state.fixedExpenses, action.payload) };
    case REMOVE_FIXED_EXPENSE:
      return { ...state, fixedExpenses: state.fixedExpenses.filter((e) => e.id !== action.payload) };

    // Variable expenses
    case ADD_VARIABLE_EXPENSE:
      return { ...state, variableExpenses: [...state.variableExpenses, action.payload] };
    case UPDATE_VARIABLE_EXPENSE:
      return { ...state, variableExpenses: updateItem(state.variableExpenses, action.payload) };
    case REMOVE_VARIABLE_EXPENSE:
      return { ...state, variableExpenses: state.variableExpenses.filter((e) => e.id !== action.payload) };

    // Goals
    case SET_GOALS:
      return { ...state, goals: { ...state.goals, ...action.payload } };

    // Debts
    case ADD_DEBT:
      return { ...state, debts: [...state.debts, action.payload] };
    case UPDATE_DEBT:
      return { ...state, debts: updateItem(state.debts, action.payload) };
    case REMOVE_DEBT:
      return { ...state, debts: state.debts.filter((d) => d.id !== action.payload) };
    case SET_DEBT_STRATEGY:
      return { ...state, debtStrategy: action.payload };

    // Batch operations
    case BATCH_SET_FIXED_EXPENSES:
      return { ...state, fixedExpenses: action.payload };
    case BATCH_SET_VARIABLE_EXPENSES:
      return { ...state, variableExpenses: action.payload };

    // Hydrate
    case HYDRATE:
      return { ...initialState, ...action.payload };

    default:
      return state;
  }
}
